import React from 'react';

const Payment = () => {
    return (
        <div>
            <h4>Your Payment is now on going</h4>
        </div>
    );
};

export default Payment;